<template>
  <div class="page-item">
    <template v-if="type === 1">
      <div class="item line" v-for="item in list" :key="item.Id">
        <FormworkOne :hasIntroduction="false" hasFollow :row="item" posation="top">
          <div class="extInfo ">
            <div class="extInfo-item ellipsis">
              <label for="公司名称：">公司名称：</label>
              <span>{{item.EnterpriseName | empty-str}}</span>
            </div>
            <div class="extInfo-item ellipsis">
              <label for="所在区域：">所在区域：</label>
              <span>{{item.ProvinceName?`${item.ProvinceName}-${item.CityName}-${item.DistrictName}-${item.Address}`:'-'}}</span>
            </div>
            <div class="extInfo-item ellipsis">
              <label for="所属行业：">所属行业：</label>
              <template v-if="item.Industry && item.Industry.length" >
                <span v-for="(subitem,index) in item.Industry" :key="subitem.IndustryTagId">{{index === item.Industry.length-1? subitem.IndustryTagName :`${subitem.IndustryTagName}/`}}</span>
              </template>
              <template v-else>
                <span>-</span>
              </template>
            </div>
            <div class="extInfo-item ellipsis">
              <label for="真实姓名：">真实姓名：</label>
              <span>{{item.NickName | empty-str}}</span>
            </div>
          </div>
          <van-button v-if="(item.Both && item.isFollow) || (item.isBoth && item.isFollow)" class="btn" size="mini" @click.prevent="handleClick(item)">互相关注</van-button>
          <van-button v-else type="primary" class="btn" size="mini" @click.prevent="handleClick(item)">+关注</van-button>          
          <van-button v-show="!item.ChangeCard" class="btn" disabled size="mini">未交换名片</van-button>          
          <van-button v-show="item.ChangeCard" class="btn" size="mini" @click.prevent="checkCard(item)">查看名片</van-button>          
        </FormworkOne>
      </div>
    </template>
    <template v-else>
      <div class="item line" v-for="item in list" :key="item.Id">
        <FormworkOne :hasIntroduction="false" hasFollow :row="item" posation="top"></FormworkOne>
          <van-button v-if="(item.Both && item.isFollow) || (item.isBoth && item.isFollow)" class="btn" size="mini" @click.prevent="handleClick(item)">互相关注</van-button>
          <van-button v-else type="primary" class="btn" size="mini" @click.prevent="handleClick(item)">+关注</van-button>                  
      </div>
    </template>
    <EmptyPosition v-show="!list.length" type="fans"></EmptyPosition>
    <van-popup v-model="show" get-container="body" :close-on-click-overlay="false">
      <div class="cardInfo">
        <div class="header">
          <div class="header-content">
            <Avatar class="avatar" :size="25" :src="cardInfo.Avatar"></Avatar>
            <div class="van-ellipsis">
              <p class="text-big-more van-ellipsis">{{cardInfo.Name}}</p>
              <p class="text-small van-ellipsis">{{cardInfo.DepartmentName}} - {{cardInfo.PositionName}}</p>
            </div>
          </div>
          <van-icon class="close" name="close" size="20" @click="show=false"/>
        </div>
        <div class="content">
          <div class="card-item">
            <p class="text-big">{{cardInfo.EnterpriseName}}</p>
            <div>
            <span class="text-small text-gray">所属行业: </span>
              <template v-if="cardInfo.Industry && cardInfo.Industry.length" >
                <span class="text-small text-gray" v-for="(subitem,index) in cardInfo.Industry" :key="subitem.IndustryTagId">{{index === cardInfo.Industry.length-1? subitem.IndustryTagName :`${subitem.IndustryTagName}/`}}</span>
              </template>
              <template v-else>
                <span class="text-small text-gray">-</span>
              </template>    
            </div>            
          </div>
          <div class="card-item">
            <div class="card-content-item">
              <label for="地址">地址</label>
              <p>{{cardInfo.ProvinceName?`${cardInfo.ProvinceName}-${cardInfo.CityName}-${cardInfo.DistrictName}-${cardInfo.Address}`:'-'}}</p>              
            </div>
            <div class="card-content-item">
              <label for="传真">传真</label>
              <p>{{cardInfo.Fax | empty-str}}</p>              
            </div>
            <div class="card-content-item">
              <label for="座机">座机</label>
              <p>{{cardInfo.Landline | empty-str}}</p>              
            </div>
            <div class="card-content-item">
              <label for="网址">网址</label>
              <p>{{cardInfo.Website | empty-str}}</p>              
            </div>
          </div>
          <div class="card-item">
            <div class="card-content-item">
              <label for="手机">手机</label>
              <p>{{cardInfo.ContactInfo.MobilePhone | empty-str}}</p>              
            </div>
            <div class="card-content-item">
              <label for="邮箱">邮箱</label>
              <p>{{cardInfo.ContactInfo.Email | empty-str}}</p>              
            </div>
            <div class="card-content-item">
              <label for="QQ">QQ</label>
              <p>{{cardInfo.ContactInfo.QQ | empty-str}}</p>              
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import FormworkOne from '../components/formworkOne'
import EmptyPosition from '@/components/common/emptyPosition'
import Avatar from '@/components/avatar'
import { Cms } from '@/api'

export default {
  name: 'fans',
  components: { FormworkOne, EmptyPosition, Avatar },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      type: this.$mdUtils.getUserInfo('Type'),
      show: false,
      cardInfo: {
        ContactInfo: {}
      }
    }
  },
  methods: {
    async checkCard(row) {
      this.cardInfo = await this.$api(Cms.UserCardGetFollowUserCard, { FollowUserId: row.UserId })
      this.show = true
    },
    handleClick(item) {
      this.$api(Cms.FollowToggleFollow, { UserId: this.$mdUtils.getUserInfo('Id'), FollowedUserId: item.UserId }).then(() => {
        if (item.isFollow) {
          item.isFollow = false
          item.Author.FollowedQuantity -= 1
          item.isBoth = false
        } else {
          item.isFollow = true
          item.Author.FollowedQuantity += 1
          item.isBoth = true
        }
        this.$mdUtils.commitRemoveKeepAlive(['followArticle'])
        this.$emit('onChange', item)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
p {
  margin: 0 0 8px;
}
.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding-right: 20px;
  padding: 25px;
}
.btn {
  flex: none;
}
.extInfo {
  margin-top: 15px;
  border-top: 1px solid $gray;
  padding: 15px 0;
}

.extInfo-item {
  width: 250px;
  padding-bottom: 8px;
  font-size: $font-size-small;
  span {
    margin-left: 15px;
  }
}
.cardInfo {
  width: 330px;
  height: 400px;
  overflow-y: scroll;
  overflow: auto;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 330px;
    height: 104px;
    background: rgba(43, 50, 63, 1);
    color: #fff;

    &-content {
      overflow: hidden;
      display: flex;
      align-items: center;
      padding: 0 30px;

      .avatar {
        width: 46px;
        height: 46px;
        margin-right: 20px;
        flex: none;
      }
    }
    .close {
      align-self: flex-start;
      flex: none;
      padding: 10px;
    }
  }
  .content {
    padding: 0 26px;
    .card-item {
      padding: 20px 0;
      border-bottom: 1px solid $gray;
    }
    .card-content-item {
      display: flex;
      font-size: $font-size-small;
      label {
        flex: none;
        min-width: 40px;
      }
      p {
        margin-left: 20px;
        word-break: break-all;
      }
    }
  }
}
</style>

